const  Role = {
    Admin: 'Admin',
    Franchise_Admin:'FRANCHISE-ADMIN', 
    User: 'User',
    Super_Admin:'SUPER-ADMIN'    
};
export default Role;